<div id="checkout" class="container-redirect">
    <div id="main-content" class="main-content wrapper">
        <div class="columns is-multiline is-desktop page-container">
            <div class="column">
                <!-- payment redirect section -->
                <section class="step-container">
                    <div class="box">
                        <div class="box-content has-text-left">
                            @if (!errorRedirect) {
                                <p class="title is-level-1 is-size-4 has-text-centered">
                                    Vous y êtes presque, encore quelques instants le temps de vérifier votre demande de
                                    crédit...
                                </p>
                            } @else {
                                <checkout-payment-error-modal
                                    [younitedRedirectionError]="true"
                                ></checkout-payment-error-modal>
                            }
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
<form ngNoForm [method]="paymentData.method" [action]="paymentData.url" #paymentDataFormElement>
    @for (input of paymentData.inputs; track input) {
        <input type="hidden" [name]="input.nom" [value]="input.valeur" />
    }
</form>
